import { motion, useAnimation } from "framer-motion";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useEffect } from "react";

import Button from "../components/Button";
import ButtonAbsolute from "../components/ButtonAbsolute";
import SectionTitle from "../components/SectionTitle";

const FullWidthFeatureParagraph = ({ content, title }) => {
  let Link;

  if (content.link) {
    Link = content.link.uri.includes("internal:") ? (
      <Button to={content.link.uri.replace("internal:", "")}>
        {content.link.title}
      </Button>
    ) : (
      <ButtonAbsolute to={content.link.uri}>
        {content.link.title}
      </ButtonAbsolute>
    );
  }

  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: [0, 1], y: [120, 0] });
  }, [controls, content, title]);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 120 }}
        animate={controls}
        transition={{ duration: 0.4 }}
        className="full-width-feature"
      >
        <div class="image-caption-container">
          <GatsbyImage
            image={getImage(content.r.img.r.img.localFile)}
            alt={content.r.img.img.alt}
          />
          <div class="photo-caption">{content.r.img.caption}</div>
        </div>
        <div className="container full-width-body-container">
          <div className="full-width-feature-body">
            <SectionTitle message={title} />
            <div
              dangerouslySetInnerHTML={{
                __html: content.body.processed,
              }}
            />
            <div className="full-width-feature-button">{Link}</div>
          </div>
        </div>
      </motion.div>
      {/* <GatsbyImage
          image={getImage(content.r.img.r.img.localFile)}
          alt={content.r.img.img.alt}
        /> */}
    </>
  );
};

export const query = graphql`
  fragment ParagraphFullWidthFeature on paragraph__subfeature {
    title: field_subfeature_title
    body: field_subfeature_content {
      processed
    }
    link: field_subfeature_link {
      title
      uri
    }
    r: relationships {
      img: field_subfeature_image_ref {
        img: field_image {
          alt
        }
        caption: field_photo_caption
        r: relationships {
          img: field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 2, layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    }
  }
`;

export default FullWidthFeatureParagraph;
